"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardViewErrorBoundary = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var DashboardView_1 = require("./DashboardView");
/**
 * Component allowing you to embed a KPI dashboard into your application.
 *
 * @beta
 * @deprecated Will be removed in the 8.10.0 release. please see `@gooddata/sdk-ui-dashboard` and GoodData.UI documentation for v8.7
 */
var DashboardViewErrorBoundary = /** @class */ (function (_super) {
    tslib_1.__extends(DashboardViewErrorBoundary, _super);
    function DashboardViewErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: undefined,
        };
        return _this;
    }
    DashboardViewErrorBoundary.getDerivedStateFromError = function (error) {
        return {
            error: error,
        };
    };
    DashboardViewErrorBoundary.prototype.render = function () {
        var _a;
        if (this.state.error) {
            var ErrorFallback = (_a = this.props.ErrorComponent) !== null && _a !== void 0 ? _a : sdk_ui_1.ErrorComponent;
            return react_1.default.createElement(ErrorFallback, { message: this.state.error.message });
        }
        return react_1.default.createElement(DashboardView_1.DashboardView, tslib_1.__assign({}, this.props));
    };
    return DashboardViewErrorBoundary;
}(react_1.default.Component));
exports.DashboardViewErrorBoundary = DashboardViewErrorBoundary;
//# sourceMappingURL=DashboardViewErrorBoundary.js.map